import React from "react";

import ClubBooking from "components/school_money/basket/items/clubBooking/ClubBooking";
import DinnerBooking from "components/school_money/basket/items/dinnerBooking/DinnerBooking";
import Payment from "components/school_money/basket/items/payment/Payment";
import ShopItem from "components/school_money/basket/items/shopItem/ShopItem";
import CreditTopUp from "components/school_money/basket/items/creditTopUp/CreditTopUp";

export default class BasketItemGroup extends React.Component {
  
  renderItemDetail() {
    
    const { basketItemGroup } = this.props;
    const { type, groupID, items, totalPrice } = basketItemGroup.toObject();
    const payloads = items.map(item => item.get("payload"));
    
    // for simple groups that only ever have one item and pass their whole payload
    const payload = payloads.first().toObject();
    
    switch (type) {
      case "clubBooking":
        return <ClubBooking {...payload} price={totalPrice} />;
      case "dinnerBooking":
        return <DinnerBooking {...payload} price={totalPrice} />;
      case "payment":
        return <Payment paymentID={groupID} installments={payloads} totalPrice={totalPrice} />
      case "shopItem":
        return <ShopItem {...payload} price={totalPrice} />;
      case "creditTopUp":
        return <CreditTopUp {...payload} amount={totalPrice} />;
      default:
        return null;
    }
    
  }
  
  render() {
    return (
      <div className="basket-item-group">
        <hr className="basket-item-group__hr" />
        <div className="basket-item-group__body">
          { this.renderItemDetail() }
        </div>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/basket/BasketItemGroup.js